export default "__VITE_ASSET__DWfg3Jb9__"